import { createAction } from '@reduxjs/toolkit';
/**
 * YENİLEME REDDEDİLDİ, OTURUM ÖLÜ (sıra 45).
 *
 * `createApiSaga` korumalı bir istekte 401 aldı, oturumu yenilemeyi denedi ve
 * yenileme ucu oturumu REDDETTİ. Uygulamanın tek "kabuğu kapat" kancasıdır:
 * mobilde hesap sagası etkin hesabı yeniden giriş ekranına götürür
 * (`closeRejectedActive`), webde oturum sınırı geçilir ve giriş sayfası açılır.
 *
 * Aksiyon YÜK TAŞIMAZ ve kararı kendisi vermez: dinleyen taraf kimin oturumunun
 * öldüğünü KENDİ deposundan yeniden okur. Yenileme sürerken hesap değiştiyse ya
 * da aynı anda gelen yirmi 401'in yirmisi de bunu yaydıysa ikinci kapanış olmaz.
 * Ağ hatası bu aksiyonu ÜRETMEZ: yenileme fırlatır, istek yalnız hata olur.
 */
export const sessionRefreshRejected = createAction('session/refreshRejected');
//# sourceMappingURL=session-events.js.map